/**
 * 转场特效 - flipBook
 * 2019-6-5
 */
(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = factory(this);
  } else {
    factory(root);
  }
})(this, function (root) {
  // 类构造函数
  function con(scene, option) {
    this.code = option.code || 'RowSpread';
    this.maskEle = $('<div></div>').attr({ id: 'maskEle_' + scene.id });
    this.div2 = null;
    this.video2 = null;
  }

  var methods = {
    init: function (force) {
      var _this = this;
      this.duration = 1.2;
      this.startAt = 0.6;
      var nexts = this.scene.editor.sprites[this.scene.index + 1];
      if (nexts && nexts.background && nexts.background.data && nexts.background.data.type === 'Image') {
        var _img = new Image();
        _img.src = this._handleAssetsUrl(nexts.background.data.data.url);
        _img.onload = () => {
          _this.initDom()
        }
      }
      return this.supr(this.startAt, force).then(function () {
        _this.initDom()
      })
    },

    initDom: function () {
      if (this.maskEle) {
        this.maskEle.empty()
        var editor = this.scene.editor;
        if (this.nexts) {
          this.div2 = this.nexts.getTimeDom(this.startAt * 1000)
          this.div2.css({
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            clipPath: 'polygon(0 0, 100% 0, 100% 16.6%, 0 16.6%, 0 33.2%, 100% 33.2%, 100% 49.8%, 0 49.8%, 0 66.4%, 100% 66.4%, 100% 83%, 0 83%, 0 66.4%, 100% 66.4%, 100% 83%, 0 83%)'
          });
          this.video2 = this.div2.find('video')[0]
        } else {
          this.div2 = null;
          this.video2 = null;
        }

        this.maskEle.css({
          width: editor.clientWidth + 'px',
          height: editor.clientHeight + 'px',
          position: 'absolute',
          top: 0,
          left: 0,
        }).append(this.div2).hide();

        // 插入播放层的 maskEle 中
        editor.player.maskEle.append(this.maskEle);
      }
    },

    show: function (frame) {
      // 播放
      if (!this.isInit) return;
      this.supr(frame);

      var scene = this.scene,
        editor = scene.editor,
        sEle = scene.element.player; // player层的当前 scene

      var w = editor.clientWidth;

      // 播放层显示，对应scene显示
      editor.player.ele.show();
      sEle.show();

      // 衔接上一个场景页的动画(e.g.前0.75s的动画)
      if (frame <= this.entrance.end) {
        this.showFirst(frame);
      }

      // 本场景页的转场动画(e.g.后0.75s的动画)
      if (this.nexts && frame >= this.exit.start) {
        // 隐藏上一个场景页的遮罩
        this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();

        var offFrame = frame - this.exit.start; // 当前帧减去动画开始时的帧
        var nexts_ele = this.nexts.element.player; // player层中的下一个场景

        this.div2.css({
          left: this.linear(offFrame, -w, w, this.totalFrame / 2),
        }).show();

        nexts_ele.css({
          left: w
        }).hide()

        this.maskEle.show();
      }

      // 动画外的时间
      if (frame > this.entrance.end && frame < this.exit.start) {
        this.showMiddle();
      }
    },

    // 为下一个场景提供方法以完成动画衔接
    showNext: function (frame) {
      var next_ele = this.nexts.element.player,
        w = this.scene.editor.clientWidth;

      this.maskEle.show();
      this.div2.css({
        left: 0
      })
      if (this.video2) {
        this.video2.currentTime = this.nexts.background.element.playerVideo.prop('currentTime')
      }
      next_ele.css({
        left: this.linear(frame, w, -w, this.totalFrame / 2),
      }).show();
    },

    // 清空DOM,以及一些没必要对象
    clearMask: function () {
      this.maskEle.remove();
      this.maskEle = $('<div></div>').attr({ id: 'maskEle_' + this.scene.id });
      this.isInit = false;
    },
    _handleAssetsUrl: function (url) {
      if (!url) return '';
      var reg = /^\//;
      // var qiniuAssetsUrl = 'http://www.laihua.com';
      var qiniuAssetsUrl = 'https://resources.laihua.com';

      var reg2 = new RegExp(qiniuAssetsUrl + '/', 'g');
      url = url.replace(reg2, '');
      // var qiniuAssetsUrl = '';
      if (!reg.test(url)) {
        return qiniuAssetsUrl + '/' + url;
      } else {
        return qiniuAssetsUrl + url;
      }
    }
  }

  // 静态方法
  var statics = {

  }

  if (root.AnimEditor) {
    root.AnimEditor.extendScenesEffect('RowSpread', con, methods, statics);
    return;
  }

  return function (AnimEditor) {
    AnimEditor.extendScenesEffect('RowSpread', con, methods, statics);
  }
});


//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-row-spread.js
// module id = 655n
// module chunks = 16